/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useCallback, useEffect } from 'react';
import { useLessonPlayerStore } from '@stores/lessonPlayerStore';
import useWindowSize from '@hooks/useWindowSize';
import styled from '@emotion/styled';
import { Spacings } from '@styles/index';
import Image from '@base/Image';
import Popper from '@material-ui/core/Popper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import ControlButton from '../ControlButton';
import SettingsMenu from './SettingsMenu';

const SettingsWrapper = styled.div``;

const StyledPopper = styled(Popper)`
  border-radius: 4px;
  &.MuiPopover-root .MuiPaper-root {
    margin-top: ${Spacings.SPACING_2B};
  }
`;

const Settings: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [showAudioOption, setShowAudioOption] = useState(false);
  const popperRef = React.useRef(null);
  const [open, setOpen] = useState(false);
  const { player, isFullscreen } = useLessonPlayerStore();
  const { isMobile } = useWindowSize();

  const handleSettings = (e) => {
    setOpen(true);
    player.controls(false);
    setAnchorEl(e.currentTarget);
    if (open) {
      setAnchorEl(null);
      setOpen(false);
      player.controls(true);
    }
  };
  const closeDropdown = (showControls = true) => {
    if (open) {
      setAnchorEl(null);
      setOpen(false);
      if (showControls) {
        player.controls(true);
      }
    }
  };

  const renderSettingsSize = useCallback(() => {
    if (isMobile || !isFullscreen) return '24px';
    return '32px';
  }, [isMobile, isFullscreen]);

  useEffect(() => {
    const isSafari =
      navigator.vendor &&
      navigator.vendor.indexOf('Apple') > -1 &&
      navigator.userAgent &&
      navigator.userAgent.indexOf('CriOS') === -1 &&
      navigator.userAgent.indexOf('FxiOS') === -1;

    setShowAudioOption(!isSafari);
  }, []);

  return (
    <ClickAwayListener onClickAway={() => closeDropdown()}>
      <SettingsWrapper>
        <ControlButton
          tooltipTitle="Settings"
          onClick={(e) => handleSettings(e)}
        >
          <Image
            src="video-settings.svg"
            alt="Settings"
            layout="intrinsic"
            width={renderSettingsSize()}
            height={renderSettingsSize()}
          />
        </ControlButton>
        <StyledPopper
          transition
          open={open}
          popperRef={popperRef}
          anchorEl={anchorEl}
          disablePortal
          placement="top-end"
          modifiers={{
            flip: {
              enabled: false
            },
            hide: { enabled: false }
          }}
        >
          <SettingsMenu
            showAudioOption={showAudioOption}
            closeDropdown={closeDropdown}
            popper={popperRef}
          />
        </StyledPopper>
      </SettingsWrapper>
    </ClickAwayListener>
  );
};

Settings.displayName = 'Settings';

export default Settings;
